import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';

import DatePicker     from 'app/components/common/date-picker';
import EllipsisMenu   from 'app/components/common/ellipsis-menu';
import Icon           from 'app/components/common/icon';
import StandardSelect from 'app/components/common/standard-select';
import CavsDuck       from 'app/ducks/company-admin/cattr-vals';
import prompts        from 'app/prompts';

const NEW_ID = 'NEW';
const initialInputVals = {
  selectedOptionId: null,
  selectedAsOf: null,
};

class ModalEditCattrsAdvanced extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      selectedCattrId: null,
      editCavId: null,
      ...initialInputVals,
    };

    this.onClickCancelEdit = this.onClickCancelEdit.bind(this);
    this.onClickNewCav = this.onClickNewCav.bind(this);
    this.onChangeAsOf = this.onChangeAsOf.bind(this);
    this.onSelectOption = this.onSelectOption.bind(this);
    this.onClickSaveEdit = this.onClickSaveEdit.bind(this);
  }

  get selectedCattrId() {
    return this.state.selectedCattrId || this.props.companyCattrs[0]?.id;
  }

  get selectedCattr() {
    return this.props.companyCattrs.find(c => c.id === this.selectedCattrId);
  }

  get cattrOpts() {
    return this.selectedCattr?.options || [];
  }

  get inputOpts() {
    const inputOpts = [];
    this.cattrOpts.forEach(o => inputOpts.push({label: o.name, value: o.id}));
    return inputOpts;
  }

  get cattrVals() {
    const allCattrVals = this.props.cattrVals || [];
    const filteredCattrVals = allCattrVals.filter(cav => cav.customAttributeId === this.selectedCattrId);
    const sortedCattrVals = _.orderBy(filteredCattrVals, 'asOf', 'desc');
    return sortedCattrVals;
  }

  get showNewRow() {
    return this.state.editCavId === NEW_ID;
  }

  get saveBtnDisabled() {
    if (!this.state.selectedAsOf) return true;
    if (this.props.changePending) return true;
    return false;
  }

  get anyBtnDisabled() {
    if (this.props.changePending) return true;
    return false;
  }

  get saveAttrs() {
    const attrs = {
      asOf: this.state.selectedAsOf,
      customAttributeOptionId: this.state.selectedOptionId,
    };
    if (this.showNewRow) {
      attrs.customAttributeId = this.selectedCattrId;
    }
    return attrs;
  }

  onClickEditCav(cav, event) {
    event.preventDefault();
    this.setState({editCavId: cav.id, selectedAsOf: cav.asOf, selectedOptionId: cav.customAttributeOptionId});
  }
  onClickCancelEdit() {
    this.setState({editCavId: null, ...initialInputVals});
  }
  onClickNewCav() {
    this.setState({editCavId: NEW_ID, ...initialInputVals});
  }
  async onClickDeleteCav(cav, event) {
    event.preventDefault();
    const msg = 'Are you sure you want to delete this custom attribute assignment?';
    const didConfirm = await prompts.confirm({msg, danger: 'Delete'});
    if (!didConfirm) return;
    const trEl = event.target.closest('tr');
    trEl?.classList?.add('deleting');
    await this.props.deleteCav(cav.id);
  }
  onClickSaveEdit() {
    const prom = this.showNewRow
      ? this.props.createCav(this.saveAttrs)
      : this.props.updateCav(this.state.editCavId, this.saveAttrs);
    prom.then(() => {
      this.setState({editCavId: null, ...initialInputVals});
    });
  }

  onSelectOption(selectedOptionId) {
    this.setState({selectedOptionId: selectedOptionId || null});
  }

  onChangeAsOf(dateStr) {
    this.setState({selectedAsOf: dateStr});
  }

  onClickAdvCattr(cattr, event) {
    this.setState({selectedCattrId: cattr.id, editCavId: null, ...initialInputVals});
  }

  renderFormRow() {
    const {editCavId, selectedOptionId, selectedAsOf} = this.state;
    const {updatePending, createPending} = this.props;
    const isNew = editCavId === NEW_ID;
    const isPending = isNew ? createPending : updatePending;
    return (<>
      <td>
        <StandardSelect options={this.inputOpts} value={selectedOptionId} onSelect={this.onSelectOption} label="No Value" allowClear />
      </td>
      <td>
        <DatePicker onChange={this.onChangeAsOf} dateStr={selectedAsOf} />
      </td>
      <td className="btns">
        <button className="btn small blue" disabled={this.saveBtnDisabled} onClick={this.onClickSaveEdit}>{isPending ? 'Saving...' : 'Save'}</button>
        <button className="btn small secondary" disabled={this.anyBtnDisabled} onClick={this.onClickCancelEdit}>Cancel</button>
      </td>
    </>);
  }

  renderCattr() {
    if (!this.selectedCattr) return null;
    const {editCavId} = this.state;
    const showNewBtn = !editCavId;

    return (<>
      <table className="modal-emp-cattrs-adv-table">
        <tbody>
          <tr>
            <th className="left">Value</th>
            <th className="left">Effective Date</th>
            <th></th>
          </tr>
          {this.cattrVals.map((cav) => {
            const option = this.cattrOpts.find(o => o.id === cav.customAttributeOptionId);
            const isEdit = editCavId === cav.id;
            return (
              <tr key={cav.id}>
                {isEdit ? (<>
                  {this.renderFormRow()}
                </>) : (<>
                  <td>{option ? option.name : '[No Value]'}</td>
                  <td>{moment.utc(cav.asOf).format('MMM DD, YYYY')}</td>
                  <td>
                    <EllipsisMenu disabled={this.anyBtnDisabled}>
                      <a href="#" onClick={this.onClickEditCav.bind(this, cav)}><Icon.Pencil /> Edit</a>
                      <a href="#" onClick={this.onClickDeleteCav.bind(this, cav)}><Icon.Bin /> Delete</a>
                    </EllipsisMenu>
                  </td>
                </>)}
              </tr>
            );
          })}
          {this.showNewRow && (
            <tr>
              {this.renderFormRow()}
            </tr>
          )}
        </tbody>
      </table>
      {showNewBtn && (
        <button className="btn small secondary icon blue" disabled={this.anyBtnDisabled} onClick={this.onClickNewCav}><Icon.AddCircle /> New Entry</button>
      )}
    </>);
  }

  render() {
    return (<>
      <p>Effective dates are used in analytics to associate donations, volunteer hours, and other activity with custom attributes based on the activity date.</p>
      <div className="modal-emp-cattrs-adv">
        <div className="modal-emp-cattrs-adv-tabs">
          {this.props.companyCattrs.map((cattr) => {
            const isSelected = cattr.id === this.selectedCattrId;
            return (
              <div key={cattr.id} className={`modal-emp-cattrs-adv-tabs-tab ${isSelected ? 'selected' : ''}`} onClick={this.onClickAdvCattr.bind(this, cattr)}>{cattr.name}</div>
            );
          })}
        </div>
        <div className="modal-emp-cattrs-adv-cattr">
          {this.renderCattr()}
        </div>
      </div>
    </>);
  }

}

ModalEditCattrsAdvanced.propTypes = {
  companyCattrs: PropTypes.arrayOf(PropTypes.object).isRequired,
};
ModalEditCattrsAdvanced.defaultProps = {};

const stateToProps = (state) => ({
  cattrVals: CavsDuck.Slx.cattrVals(state),
  changePending: CavsDuck.Slx.changePending(state),
  updatePending: CavsDuck.Slx.updatePending(state),
  deletePending: CavsDuck.Slx.deletePending(state),
  createPending: CavsDuck.Slx.createPending(state),
});
const dispatchToProps = (dispatch) => ({
  updateCav: (cavId, attrs) => dispatch(CavsDuck.Ax.updateCattrValue(cavId, attrs)),
  deleteCav: (cavId) => dispatch(CavsDuck.Ax.deleteCattrValue(cavId)),
  createCav: (attrs) => dispatch(CavsDuck.Ax.createCattrValue(attrs)),
});

export default connect(stateToProps, dispatchToProps)(ModalEditCattrsAdvanced);
